import Constants from '@/Constants';
import { Family } from '@/models/Family';
import { ApplicationState } from '@/store';
import { useSelector } from 'react-redux';
import { useGet } from './useGet';

const getKey = (applicationId: number, isAdmin: boolean = false) => {
    if (!isAdmin || !applicationId) {
        return null;
    }

    return Constants.LMS_GET_FAMILY_LIST.replace('%appId', applicationId.toString());
};

export const useFamily = () => {
    const applicationId: number = useSelector((state: ApplicationState) => state.identity.data.user.applicationId);
    const isAdmin: boolean = useSelector((state: ApplicationState) => state.identity.data.user.admin);

    const { data: families = [] } = useGet<Family[]>(getKey(applicationId, isAdmin));

    return { families };
};
